// @ts-strict-ignore
import type { EndpointAdapter, Mapper } from '@empathyco/x-adapter'
import type { SearchRequest, SearchResponse } from '@empathyco/x-types'
import { endpointAdapterFactory } from '@empathyco/x-adapter'

import { searchRequestMapper } from '../mappers/search-request.mapper'
import { searchResponseMapper } from '../mappers/search-response.mapper'

const requestProperties: RequestInit = {
  method: 'GET',
  headers: {},
}

function setRequestToken(token: string): void {
  ;(requestProperties.headers as Record<string, string>).Authorization = `Bearer ${token}`
}

export function getSearchEndpointAdapter(
  endpoint: string,
): EndpointAdapter<SearchRequest, SearchResponse> {
  return endpointAdapterFactory({
    endpoint,
    defaultRequestOptions: {
      sendParamsInBody: false,
      sendEmptyParams: true,
      properties: requestProperties,
    },
    requestMapper: (from, context) => {
      setRequestToken(from.extraParams.token)
      return searchRequestMapper(from, context)
    },
    responseMapper: searchResponseMapper as unknown as Mapper<any, SearchResponse>,
  })
}
